// src/components/homeComponents/Manifesto.jsx
import React, { useEffect, useRef } from "react";
import styled from "styled-components";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const TEXT =
  "We don't chase trends. We make people stop, feel something, and remember your name long after the scroll.";

const Manifesto = () => {
  const sectionRef = useRef(null);
  const wordsRef = useRef([]);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(
        wordsRef.current,
        { color: "#241c33" },
        {
          color: "#ffffff",
          ease: "none",
          stagger: 0.5,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top top",
            end: "+=160%",
            scrub: true,
            pin: true,
            anticipatePin: 1,
          },
        }
      );
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  const words = TEXT.split(" ");

  return (
    <Section ref={sectionRef}>
      <div className="inner">
        <span className="kicker">WHAT WE BELIEVE</span>
        <p>
          {words.map((w, i) => (
            <span
              className="w"
              key={i}
              ref={(el) => (wordsRef.current[i] = el)}
            >
              {w}&nbsp;
            </span>
          ))}
        </p>
      </div>
    </Section>
  );
};

const Section = styled.section`
  background: #08040c;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 7%;

  .inner {
    max-width: 1100px;
    .kicker {
      display: block;
      text-align: center;
      font-family: "Montserrat";
      letter-spacing: 0.45em;
      font-size: 0.72rem;
      color: #836caf;
      font-weight: 500;
      margin-bottom: 1.4em;
    }
    p {
      font-family: "Readex Pro", sans-serif;
      font-weight: 300;
      font-size: clamp(1.8rem, 4.4vw, 3.8rem);
      line-height: 1.25;
      text-align: center;
    }
    .w {
      display: inline-block;
    }
  }
`;

export default Manifesto;
